import { defineComponent as _defineComponent } from 'vue'

// Keep in sync with `ContactFormController`
export const DIAGNOSTIC_CATEGORIES = [
  'javascript',
  'cookies',
  'api.padlet.com',
  'padletcdn.com',
  'padlet.pics',
  'padlet.net',
  'cdnjs.cloudflare.com',
  'googleapis.com',
  'googleusercontent.com',
  'images.unsplash.com',
  'websocket',
] as const
export type DiagnosticCategory = typeof DIAGNOSTIC_CATEGORIES[number]
export type DiagnosticResults = Record<DiagnosticCategory, boolean | undefined>
const __default__ = {}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ContactFormDiagnostic',
  emits: ['result'],
  setup(__props, { emit }) {

const diagnosticResults: DiagnosticResults = DIAGNOSTIC_CATEGORIES.reduce(
  (prev, category) =>
    Object.assign(
      prev,
      [
        'padlet.pics',
        'cdnjs.cloudflare.com',
        'googleapis.com',
        'googleusercontent.com',
        'images.unsplash.com',
      ].includes(category)
        ? { [category]: false } // for async checks, we assume they are false by default
        : { [category]: undefined }, // for other checks, they are undefined by default
    ),
  {},
) as DiagnosticResults

const runDiagnostics = async (): Promise<void> => {
  await Promise.all(
    DIAGNOSTIC_CATEGORIES.map(async (category) => {
      const result = await runDiagnostic(category)
      diagnosticResults[category] = result
    }),
  )
}

function asyncLoadImage(url: string): Promise<boolean> {
  return new Promise((resolve) => {
    const image = new Image()
    let done = false
    image.onload = function () {
      resolve(true)
      done = false
    }
    image.src = url
    setTimeout(() => {
      if (!done) resolve(false)
    }, 3000)
  })
}

const runDiagnostic = async (category: DiagnosticCategory): Promise<boolean> => {
  switch (category) {
    case 'javascript':
      return true
    case 'cookies':
      return navigator.cookieEnabled
    case 'api.padlet.com':
      try {
        await fetch('https://api.padlet.com/api/5/users/12')
        return true
      } catch (e) {
        return false
      }
    case 'padletcdn.com':
      return (window as any).domains?.['padletcdn.com']
    case 'padlet.pics':
      return asyncLoadImage('https://padlet.pics/1/image?url=https%3A%2F%2Fpadlet.com%2Ffavicon.ico')
    case 'padlet.net':
      return (window as any).domains?.['padlet.net']
    case 'cdnjs.cloudflare.com':
      return new Promise((resolve) => {
        const anchor = document.getElementsByTagName('script')[0] as HTMLElement
        const a = document.createElement('script')
        let done = false
        a.type = 'text/javascript'
        a.async = true
        a.src = 'https://cdnjs.cloudflare.com/ajax/libs/js-cookie/2.1.2/js.cookie.min.js'
        a.onload = function () {
          resolve(true)
          done = true
        }
        ;(anchor.parentNode as HTMLElement).insertBefore(a, anchor)
        setTimeout(() => {
          if (!done) resolve(false)
        }, 3000)
      })
    case 'googleapis.com':
      return asyncLoadImage(
        'https://padlet-uploads.storage.googleapis.com/93511621/281def7aba6021983b2db8f8972ccae0/Bishan_home.jpg',
      )

    case 'googleusercontent.com':
      return asyncLoadImage(
        'https://lh5.googleusercontent.com/LNhmlmZ83hCLPxEAik9nAHAS5XCrsVpx3EY4Nzp5EGRqFpwiDpp2wcq_Q5ILsbmLfejbd-_ll3GnTi1ICYJ-8CYPgH6iuOJgRFs=w32-h32-p',
      )
    case 'images.unsplash.com':
      return asyncLoadImage(
        'https://images.unsplash.com/photo-1579149254497-5b90981f0c93?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=100',
      )
    case 'websocket':
      return new Promise((resolve) => {
        const socket = new WebSocket('wss://padlet.com/diagnostics/websocket')
        let done = false
        socket.addEventListener('message', () => {
          resolve(true)
          done = true
          socket.close()
        })
        socket.addEventListener('open', () => {
          socket.send('ping')
        })
        setTimeout(() => {
          if (!done) resolve(false)
        }, 3000)
      })
  }
}

runDiagnostics().then(() => {
  emit('result', diagnosticResults)
})

return { __sfc: true,DIAGNOSTIC_CATEGORIES, diagnosticResults, runDiagnostics, asyncLoadImage, runDiagnostic, emit }
}

})